<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]="data"><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ this.title }}">
    <div class="container" style="width: 500px;">
      <div class="row">
        <div class="col-5 m-4 image" *ngFor="let file of data.files; let i = index" style="background-color: black;" [ngClass]="(fileType && file.Filename.startsWith(fileType)) ? 'show' : 'hidden'" [ngStyle]="{'background-image': (file.Filename.endsWith('jpg') || file.Filename.endsWith('jpeg') || file.Filename.endsWith('png')) ? 'url(' + file.Uri + ')' : 'transparent' }">
          <button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" class="remove" (click)="removeFile(file, i)"><mat-icon class="close-icon">delete</mat-icon></button>
          <div class="more-images">
            <div style="color: white; background-color: rgba(0, 0, 0, 0.2);">{{ file.Filename }}</div>
          </div>
        </div>
        <div class="col-5 m-4 new-image" (click)="beginUpload()">
          <button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" class="remove add"><mat-icon class="add-icon">file_present</mat-icon></button>
          <div class="more-images">
            <div>{{ 'Turbo.Service.CreateServiceRequestDialog.AddFile' | translate : 'Add file' }} +</div>
          </div>
        </div>
      </div>
    </div>
    <input #txtFile type="file" style="visibility:hidden" (change)="uploadFiles($event.target.files)" />
    <div class="loader" *ngIf="loading">
      <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
      <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading"></mat-progress-bar>
    </div>
  </t4-container>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="col-12" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()" [disabled]="loading">{{ 'Turbo.Service.CreateServiceRequestDialog.Save' | translate : 'Save' }}</button>
  </div>
</mat-dialog-actions>
